
const globals = {}

export default globals
